import { IMachineUIMetricsConfigService } from './contracts/machineUIMetricsConfig.service';
import { MachineMetricsType } from '_clean-code/pages/UIConfigScreen/MachineMetricsComponent';
import apiClient from '../../api/index';
/* eslint-disable import/prefer-default-export */
import { createUrl } from '_clean-code/utils/urlHelper';

type MetricConfig = { order: number; metric: string; enabled: boolean };
export const MachineUIMetricsConfigService: IMachineUIMetricsConfigService = {
  async saveMachineUIMetricsConfig<T extends MetricConfig>(
    machineId: number | number[],
    config: MachineMetricsType<T>
  ): Promise<void> {
    if (Array.isArray(machineId)) {
      const responseBulk = await apiClient.request(
        'PATCH',
        createUrl(`/machines/config-ui`).toStringUrl(),
        { ...config, machineIds: machineId }
      );
      return responseBulk as any;
    }
    const response = await apiClient.request(
      'PATCH',
      createUrl(`/machines/${machineId}/config-ui`).toStringUrl(),
      config
    );

    return response as any;
  },

  async getMachineUIMetricsConfig(machineId: string) {
    const viewTypes = ['desktopNonKpi', 'tvKpi'] as const;

    const requests = viewTypes.map((viewType) =>
      apiClient.request(
        'GET',
        createUrl(`/machines/${viewType}/${machineId}/config-ui`).toStringUrl()
      )
    );

    const responses = await Promise.all(requests);

    const result = viewTypes.reduce((acc, viewType, index) => {
      acc[viewType] = responses[index] as string[];
      return acc;
    }, {} as Record<typeof viewTypes[number], string[]>);

    return result;
  }
};
